import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db542fbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "annbg" }
const _hoisted_2 = { class: "ann" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createBlock(_component_van_overlay, {
    show: $setup.showAnn,
    "lock-scroll": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "anndialog",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          style: _normalizeStyle({ backgroundImage: `url(${$setup.ic_ann})` })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_list, { class: "dd" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString($setup.annnotice), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createElementVNode("img", {
            class: "okBtn",
            src: $setup.annOk,
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.close())),
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_3)
        ], 4 /* STYLE */),
        _createElementVNode("img", {
          class: "offbtn",
          src: $setup.annClose,
          alt: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.close()))
        }, null, 8 /* PROPS */, _hoisted_4)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}